import { render, staticRenderFns } from "./ClaimInvite.vue?vue&type=template&id=e2e5c5dc&"
import script from "./ClaimInvite.vue?vue&type=script&lang=js&"
export * from "./ClaimInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports